import classNames from "classnames";

import "./storeStatus.scss";

type StoreStatusProps = {
    isOpen: boolean;
    statusText?: string;
    openClosesAt?: string;
};

const StoreStatus = ({
    isOpen,
    statusText,
    openClosesAt
}: StoreStatusProps) => {
    return (
        <p
            className={classNames(
                "store-status",
                isOpen && "store-status--open"
            )}
        >
            <span>{statusText}</span>
            {openClosesAt && (
                <>
                    <span className={"store-status__separator"} />
                    <span>{openClosesAt}</span>
                </>
            )}
        </p>
    );
};

export { StoreStatus };
